<template>
    <div class="search">
        <!-- 未連接至網路的提醒 -->
        <div v-if="!closeOffline && isOffline" class="v3offline">
            <i class="icon-exclamation-mark-circle"></i>
            <p>未連接至網路</p>
            <div @click="closeOfflineHandle"><i class="icon-close"></i></div>
        </div>
        <div class="search__block">
            <div class="search__panel">
                <!-- 放大鏡 AB -->
                <span class="search__panel__magnifier"><i class="icon-search"></i></span>
                <input class="search__panel__input" type="text" placeholder="請輸入搜尋關鍵字" :style="[deleteBtnStatus ? {paddingRight: '40px'} : null]" v-model="searchWords" ref="autoFocusInput"/>
                <!-- 叉叉 AB -->
                <div v-if="deleteBtnStatus" class="search__panel__cross" @click="deleteInputText"><i class="icon-close-circle"></i></div>
                <span v-if="!deleteBtnStatus" class="search__panel__word" @click="search">搜尋</span>
            </div>
        </div>
         <div class="search__block articleList">
            <mescroll-vue :down="getMescrollDown()" :up="getMescrollUp()" @init="mescrollInit(arguments)">
             <ul>
				<li v-for="(news,news_ind) in news" :key="news_ind">
                    <router-link :to="{name:'v3newsDetail', params: { id : news.news_id}}">
                        <span class="articleTag">{{news.news_type}}</span>
                        <div class="articleContent">
                            <div class="articleContentImg" v-if="news.title_img !== ''" v-lazy:background-image="news.title_img" ></div> 
                            <div class="articleContentImg" v-if="news.title_img == ''"></div>
                            <span class="articleContentNote">{{news.title}}</span>
                            <span class="articleContentIcon"><i class="icon-right-roundedline"></i></span>
                        </div>
                    </router-link>
                </li>
                <!-- BD 不需要此功能 -->
                <!-- <div class="searchDone" v-if="currentSearchingKeyword !== '' && totalFind === news.length">
                    <div></div>
                    <p>已幫你完成全部查找, 共{{totalFind}}個結果</p>
                </div> -->
                <div class="articleListEmpty" v-if="!isSearching && currentSearchingKeyword !== '' && news.length === 0">
                    <i class="icon-empty-status"></i>
                    <p>噢不！<br>沒有搜尋結果，試試別的關鍵字吧！</p>
                </div>
            </ul>
            </mescroll-vue>
        </div>
        <!-- v3 無圖案 Toast -->
        <div v-show="v3Toast.show" class="v3Toast">{{v3Toast.text}}</div>
    </div>
</template>

<script lang="js">
import axios from 'axios'
import MescrollVue from 'mescroll.js/mescroll.vue'
axios.defaults.timeout = 1000 * 10

// CommunityUser 路人模式
// CommunityUserToken 會員模式
// * 變更權限: 會員搜尋只需要傳送裝置碼那個 token 就可以過了
const GetSearchNewsByTitle = (params) => axios.get(`${process.env.SmartlifeCoreApi}/v3.0/Committee/SearchNewsByTitle`,{
  headers:{kingnetauth: `CommunityUser ${localStorage.getItem("v3token")}`},
  params
}).then(data => [null, data]).catch(err => [err, null])

export default {
    data () {
        return {
            closeOffline: false,
            mescrollObject: null,
            loading: true,
            loadingStyle: false,
            news:[],
            currentSearchingKeyword: '',
            searchWords: '',
            isSearching: false,
            deleteBtnStatus: false,
            totalFind: 0,
            v3Toast:{
                show: false,
                text: '',
                duration: 1000
            },
            toastTimer: null
        }
    },
    components: {
        MescrollVue
    },
    watch: {
        searchWords: function() {
            this.deleteBtnStatus = false
        },
        isOffline: function(val) {
            // 在下次無網路時再度打開上面的 top tip
            if (!val) this.closeOffline = false
        }
    },
    mounted() {
        // 一進來頁面初始自動聚焦在輸入框
        this.$nextTick(() => this.$refs.autoFocusInput.focus())
    },
    methods: {
        closeOfflineHandle() {
            this.closeOffline = true
        },
        // 顯示 v3Toast
        showV3Toast(text) {
            clearTimeout(this.toastTimer)
            this.v3Toast.text = text;
            this.v3Toast.show = true;
            this.toastTimer = setTimeout(() => {
                this.v3Toast.show = false;
            }, this.v3Toast.duration);
        },
        // 上拉加載 (註冊)
        getMescrollUp () {
            const vm = this
            return {
                auto: false,
                callback: vm.loadMoreData,
                htmlLoading: '<p class="upwarp-progress mescroll-rotate"></p><p class="upwarp-tip">載入更多</p>',
                htmlNodata: '<p class="upwarp-nodata">噢不！沒有更多了</p>',
                textInOffset: '載入更多',
                textOutOffset: '',
                textLoading: '載入中...'
            }
        },
        // 下拉更新 (註冊)
        getMescrollDown() {
            const vm = this
            return {
                use: false,
                auto: false,
                callback: vm.refreshAllData,
                textInOffset: '下拉更新',
                textOutOffset: '',
                textLoading: '載入中...'
            }
        },
        // 滑到最底層載入更多文章方法
        loadMoreData() {
            if (this.isOffline) {
                this.showV3Toast('網路狀態異常')
                this.mescrollObject.hideUpScroll(true)
                return
            }
            this.GetSearchResult(this.currentSearchingKeyword)
        },
        // 單一頁面更新機制 ( 清空文章 )
        refreshAllData(mescroll) {
            if (this.isOffline) {
                this.showV3Toast('網路狀態異常')
                return
            }
            if (this.news.length) {
                this.news = []           
                this.mescrollObject.optUp.hasNext = true
                this.GetSearchResult(this.currentSearchingKeyword)
            }          
        },
        mescrollInit(arg) {
            this.mescrollObject = arg[0]
        },
        deleteInputText() {
            this.searchWords = ""
            this.deleteBtnStatus = false
        },
        search() {
            if (this.isOffline) {
                this.showV3Toast('網路狀態異常')
                return
            }
            if (this.searchWords.length < 2) {
                this.$gtm.trackEvent({
                    event: 'search_under2words',
                });
                this.showV3Toast('請輸入至少兩個字元')
                return
            } else {
                this.$gtm.trackEvent({
                    event: 'search_inputContent',
                    label: "inputContent",
                    value: this.searchWords
                });
            }
            this.isSearching = true
            this.mescrollObject.optUp.hasNext = true
            this.deleteBtnStatus = true
            this.currentSearchingKeyword = this.searchWords
            this.news = [];
            this.GetSearchResult(this.currentSearchingKeyword)
        },
        async GetSearchResult(keyword) {
            if (!keyword) {
                this.mescrollObject.hideUpScroll(true)
                this.isSearching = false
                return
            } 
            let params = {
                Title: keyword,
                Skip: this.news.length,
                Quantity: 10
            }
            const [err, SearchRes] = await GetSearchNewsByTitle(params)
            if (err) {
                console.warn('[GetSearchNewsByTitle ERROR]', err)
                this.isSearching = false
                document.location.href = '/#/v3search/?KNSTMethod=timeout'
                 // ErrorMessage.Code 401000 檢查到非會員用戶
                return 
            }
            if (SearchRes) {
                if (!SearchRes.data.Data) {
                    document.location.href = '/#/v3search/?KNSTMethod=error'
                    console.warn('[GetSearchNewsByTitle ERROR]')
                    return 
                }
                this.totalFind = SearchRes.data.Data.Total
                if (SearchRes.data.Data.Articles.length > 0) {
                    this.news = this.news.concat(SearchRes.data.Data.Articles.map(HanderFormatFromAPI)) 
                    this.mescrollObject.hideUpScroll(true)
                    if (this.news.length >= SearchRes.data.Data.Total) {
                        this.mescrollObject.optUp.hasNext = false
                    }
                } else {
                    this.$gtm.trackEvent({
                        event: 'search_empty',
                    });
                    this.mescrollObject.hideUpScroll(true)
                }
                this.isSearching = false
            }
        },
        chn_tag(news_type){
            return this.$root.GetNewsTypeChn(news_type)
        }
    },
    beforeRouteLeave (to, from, next) {
        const vm = this
        if(vm.isOffline){
            vm.showV3Toast('網路狀態異常')
        }else{
            next()
        }
    }
}

function HanderFormatFromAPI(e) {
  return {
    news_id: e.Id,
    news_type: e.MainTypeName,
    news_typeId: e.MainTypeId,
    news_subType: e.SubTypeName,
    news_subTypeId: e.SubTypeId,
    title: e.Title,
    title_img: e.Title_img,
    abstract_note: e.AbstractNote
  }
}

</script>

<style lang="css">
.v3Toast {
    position: fixed;
    left: 50%;
    top: 50%;
    border-radius: 10px;
    transform: translate(-50%, -50%);
    line-height: 27px; /* 2020/11/07 10:59 捨棄 gulidline 進行調整 */
    background: rgba(0,0,0,.7); /* 2020/11/07 10:59 捨棄 gulidline 進行調整 */
    padding: 7px 10px 6px; /* 2020/11/07 10:59 捨棄 gulidline 進行調整 */
    color: #fff;
    font-size: 15px; /* 2020/11/07 10:59 捨棄 gulidline 進行調整 */
    font-weight: 500;
}
.v3offline {
    position: fixed;
    z-index: 99;
    width: 100%;
    height: 44px;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 21px;
    font-size: 15px;
    font-weight: 400;
    text-align: center;
    color: #fff;
    background: rgba(66, 137, 167, .9); /* #4289a7 2020/11/19 13:37 BD mean this color */ 
    -webkit-transition: .5s;
    transition: .5s;
}
.v3offline > i {
    margin-right: 9px;
    font-size: 19px;
    width: 19px;
    height: 19px;
}
.v3offline div {
    position: absolute;
    top: 12px;
    right: 16px;
    font-size: 18px;
    width: 18px;
    height: 18px;
}
::-webkit-input-placeholder, ::-ms-input-placeholder, ::placeholder {
    color: #999;
}

.search {
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: 100vh;
    background-color: #fff;
}

.search .search__block:nth-child(1) {
    height: 45px;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.15);
}

.search .search__block:nth-last-child(1) {
    flex: 1
}

.search .search__block .search__panel {
    display: flex;
    padding: 6px 9px 5px 8px;
    background-color: #fff;
    position: relative;
    align-items: center;
}

.search .search__block .search__panel__magnifier {
    position: absolute;
    top: 50%;
    left: 20px;
    width: 20px;
    height: 20px;
    transform: translate(0, -50%);
    display: flex;
    justify-content: center;
    align-items: center;
    color: #999;
}

.search .search__block .search__panel__input {
    border-radius: 16px;
    background-color: #F2F2F2;
    flex: 1;
    padding: 5px 10px 5px 40px;
    font-size: 15px;
    font-weight: 400;
    line-height: 22px;
    color: #484848;
    border: none
}

.search .search__block .search__panel__input:focus {
    outline: none;
}

.search .search__block .search__panel__cross {
    position: absolute;
    top: 50%;
    right: 18px;
    width: 16px;
    height: 16px;
    transform: translate(0, -50%);
    color: #999;
}

.search .search__block .search__panel__word {
    color: #46B39A;
    font-size: 15px;
    font-weight: 400;
    margin-left: 11px
}

.searchDone {
    flex: 1;
    min-height: 100px;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 15px;
    font-weight: 500;
    color: #999;
}

.searchDone > div {
    width: 50px;
    height: 50px;
    /* background-image: url("../../assets/Result_Empty.svg");
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    margin-bottom: 10px; */
}

.search .articleList {
    height: calc(100vh - 45px);
}

.search .articleList ul {
    margin: 0px;
    min-height: calc(100vh - 45px);
    display: flex;
    flex-direction: column;
}
.search .articleList ul > li {
    padding: 16px 22px 21px 12px;
    border-bottom: 1px solid #eee;
    overflow: hidden;
    box-sizing: border-box;
    position: relative;
    width: 100%;
}
.search .articleList ul > li > a {
    padding: 0;
}
.search .articleList ul > li .articleTag {
    color: #46b39a;
    align-self: flex-start;
    margin-bottom: 12px;
    background-color: #efeff4;
    padding: 0px 8px 1px;
    font-weight: 400;
    font-size: 13px;
    border-radius: 13px;
    line-height: initial;
    display: inline-block;
}
.search .articleList ul > li .articleContent {
	display: flex;
}
.search .articleList ul > li .articleContent .articleContentImg {
    height: 60px;
    width: 90px;
    border-radius: 4px;
    background-repeat: no-repeat;
    background-size: cover;
    background-color: #e8e8e8;
    background-position: center center;
}
.search .articleList ul > li .articleContent .articleContentNote {
    flex: 1;
    padding: 0 4px 0 12px;
    font-size: 16px;
    line-height: 20px;
    text-align: left;
    font-weight: bold; /* 2020/11/23 怎麼又要粗體了 */
    color: #484848;
    overflow: hidden;
    word-break: break-all;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
}
.search .articleList ul > li .articleContent .articleContentIcon {
    font-size: 18px;
    line-height: 18px;
    align-self: center;
    color: #46b39a;
}
.search .articleList ul .articleListEmpty {
    position: absolute;
    top: 0;
    width: 100%;
    height: calc(100vh - 44px - 50px);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 15px;
    font-weight: 500;
    color: #999;
    pointer-events: none;
}
.search .articleList ul .articleListEmpty > i {
    font-size: 60px;
    margin-bottom: 20px;
}
.search .articleList ul .articleListEmpty > p {
    text-align: center;
    line-height: 24px;
    font-weight: 400;
    font-size: 15px;
}
</style>


// WEBPACK FOOTER //
// src/components/v3/search.vue